export default __webpack_public_path__ + "static/sea_breath_2-58f9b4dc7d78749ba7623d8dc4620e97.png";